import { Future, FIELDS } from 'modules/cm/domain/Case/Applicant/Income/Future/Future';
import { Mapper } from 'modules/cm/mapper/types';
import { fromDomainToApiMapper } from 'modules/cm/mapper/mappings';

const futureIncomeMapper: Mapper<any, Future> = {
  mapApiToDomain: (api): Future => {
    return {
      [FIELDS.MINIMUM_RETIRED_INCOME]: api.minimumRetiredIncome,
      [FIELDS.FUTURE_INCOME_TOTAL]: api.futureIncomeTotalIncome,
      [FIELDS.EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: api.employedAnticipatedGrossAnnualIncome,
      [FIELDS.EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: api.employedIncomeDetails,
      [FIELDS.SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: api.selfEmployedAnticipatedGrossAnnualIncome,
      [FIELDS.SELF_EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: api.selfEmployedIncomeDetails,
      [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME]: api.minimumTaxableRetiredIncome,
      [FIELDS.HAS_TAXABLE_RETIRED_INCOME_CONTINUING]: api.hasTaxableRetiredIncomeContinuing,
      [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME]: api.minimumTaxFreeRetiredIncome,
      [FIELDS.HAS_TAX_FREE_RETIRED_INCOME_CONTINUING]: api.hasTaxFreeRetiredIncomeContinuing,
      [FIELDS.OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME]: api.otherIncomeAnticipatedGrossAnnualIncome,
      [FIELDS.OTHER_INCOME_DETAILS]: api.otherIncomeDetails,
      [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME_DETAILS]: api.minimumTaxableRetiredIncomeDetails,
      [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME_DETAILS]: api.minimumTaxFreeRetiredIncomeDetails,
      [FIELDS.FUTURE_INCOME_PENSION]: api.futureIncomePensionIncome,
    };
  },

  mapDomainFieldToAPI: (field: string, value: any) => {
    const { mapNumber } = fromDomainToApiMapper;
    const map: Map<string, (value: any) => any> = new Map<string, (value: any) => any>([
      [FIELDS.EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME, mapNumber],
      [FIELDS.SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME, mapNumber],
      [FIELDS.OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME, mapNumber],
    ]);

    const mapper = map.get(field);

    return mapper ? mapper(value) : value;
  },

  mapDomainNameToAPI: (field: string) => {
    const map: Map<string, string> = new Map([]);

    const mapper = map.get(field);

    return mapper || field;
  },
};

export const mapDomainToAPI = (form: Future): any => {
  return {
    minimumRetiredIncome: form[FIELDS.MINIMUM_RETIRED_INCOME],
    futureIncomeTotalIncome: form[FIELDS.FUTURE_INCOME_TOTAL],
    employedAnticipatedGrossAnnualIncome: form[FIELDS.EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME],
    employedIncomeDetails: form[FIELDS.EMPLOYED_ANTICIPATED_RETIREMENT_DATE],
    selfEmployedAnticipatedGrossAnnualIncome: form[FIELDS.SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME],
    selfEmployedIncomeDetails: form[FIELDS.SELF_EMPLOYED_ANTICIPATED_RETIREMENT_DATE],
    minimumTaxableRetiredIncome: form[FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME],
    hasTaxableRetiredIncomeContinuing: form[FIELDS.HAS_TAXABLE_RETIRED_INCOME_CONTINUING],
    minimumTaxFreeRetiredIncome: form[FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME],
    hasTaxFreeRetiredIncomeContinuing: form[FIELDS.HAS_TAX_FREE_RETIRED_INCOME_CONTINUING],
    otherIncomeAnticipatedGrossAnnualIncome: form[FIELDS.OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME],
    otherIncomeDetails: form[FIELDS.OTHER_INCOME_DETAILS],
    minimumTaxableRetiredIncomeDetails: form[FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME_DETAILS],
    minimumTaxFreeRetiredIncomeDetails: form[FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME_DETAILS],
    futureIncomePensionIncome: form[FIELDS.FUTURE_INCOME_PENSION],
  };
};

export default futureIncomeMapper;
